import * as React from 'react';
import {Route, RouteProps} from 'react-router';
import {connect} from 'react-redux';
import classNames from "classnames";

import {LoginScreen} from "../login-screen/LoginScreen";
import styles from './PrivateRoute.module.scss';
import {TopMenuBarScreenContainer} from "../../components/top-menu-bar/TopMenuBarScreenContainer";
import AuthorizedProps from "./AuthorizedProps";
import PrivateRouteProps from "./PrivateRouteProps";
import {iRootState} from "../../../store/store";


export const requireAuth = (WrappedComponent: any) => {
    const Auth: React.FC<AuthorizedProps> = ({isAuthenticated}) => {
        
        return <div style={{
            display: "flex",
            flex: 1
        }}> {isAuthenticated ?
            (
                <>
                    <div className={classNames(styles.container, styles.containerWithoutMenu)}>
                        <>
                            <TopMenuBarScreenContainer/>
                            <WrappedComponent/>
                        </>
                    </div>
                </>
            )
            : <LoginScreen/>}</div>;
    };
    
    return connect(
        (state: iRootState, ownProps: RouteProps) => ({
            isAuthenticated: state.Identity.isLogged,
            ...ownProps
        })
    )(Auth);
};

export const PrivateRoute: React.FC<PrivateRouteProps> = ({component, ...rest}) => (
    <Route component={component ? requireAuth(component) : undefined} {...rest} />
);